// extracted by mini-css-extract-plugin
export default {"tableBody":"TableBody_tableBody__D9jyg"};